import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "./dialog";
export function Modal({ open, onOpenChange, title, description, children, footer, closeLabel, busy = false, className, }) {
    return (_jsx(Dialog, { open: open, onOpenChange: (next) => {
            if (!busy)
                onOpenChange(next);
        }, children: _jsxs(DialogContent, { className: className, ...(!description ? { "aria-describedby": undefined } : {}), closeLabel: closeLabel, hideClose: busy, onEscapeKeyDown: (event) => {
                if (busy)
                    event.preventDefault();
            }, onPointerDownOutside: (event) => event.preventDefault(), children: [_jsxs(DialogHeader, { children: [_jsx(DialogTitle, { children: title }), description && _jsx(DialogDescription, { children: description })] }), children, footer && _jsx(DialogFooter, { children: footer })] }) }));
}
//# sourceMappingURL=modal.js.map